import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteProjectChatHistoryApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.DELETE_PROJECT_CHAT_HISTORY,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteProjectChatHistoryApi;